// Theme navigation starts
// --------------------------------------------------------------------------------------------------------------------

var navbar = $("#navbar");
var siteHeaderMenu = $(".navbar-nav");

// Hamburger menu icon
var hamburger = document.querySelector(".navbar-toggler");
// On click
hamburger.addEventListener("click", function () {
    // Toggle class "is-active"
    hamburger.classList.toggle("is-active");

    // $('#navbar').toggleClass('show');
});

// Toggles the sub-menu when dropdown toggle button accessed
siteHeaderMenu.find(".dropdown-toggle").on("click", function (e) {
    var dropdownMenu = $(this).nextAll(".dropdown-menu");
    var dropdownLink = $(this).prev(".nav-link");
    var dropdownLinkOthers = $(this).parent().siblings(".menu-item-has-children").find(".nav-link");
    var dropdownMenuOthers = $(this).parent().siblings(".menu-item-has-children").find(".dropdown-menu");
    var dropdownToggleOthers = $(this).parent().siblings(".menu-item-has-children").find(".dropdown-toggle");
    console.log("drops " + $(this).parent());
    dropdownLink.toggleClass("font-weight-bold");
    //Close other menus
    dropdownToggleOthers.removeClass("toggled-on");
    dropdownMenuOthers.removeClass("toggled-on");
    dropdownLinkOthers.removeClass("font-weight-bold");
    dropdownToggleOthers.attr("aria-expanded",false);
    dropdownMenuOthers.attr("aria-hidden",true);
    if ($(this).siblings("a").attr("href") != "#") {
        $(this).toggleClass("toggled-on");
        dropdownMenu.toggleClass("toggled-on");

        $(this)
            .next(".dropdown-menu")
            .attr(
                "aria-hidden",
                $(this).next(".dropdown-menu").attr("aria-hidden") === "true"
                    ? "false"
                    : "true"
            );

        $(this).attr(
            "aria-expanded",
            $(this).attr("aria-expanded") === "false" ? "true" : "false"
        );
    }
});

// Aria arvot hoverille
/* siteHeaderMenu.find(".sub-menu-parent").on("mouseenter", function (e) {
    $(this)
        .children(".dropdown-menu")
        .attr(
            "aria-hidden",
            $(this).children(".dropdown-menu").attr("aria-hidden") === "true"
                ? "false"
                : "true"
        );
}); */

// jos päämenun linkillä  on linkkinä #, niin avataan pudotusvalikko klikattaessa
function menuWithTag() {
    $(".sub-menu-parent").on("click", function (e) {
        var $this = $(this);
        //Close other menus
        $(this).siblings().children(".dropdown-menu").removeClass("toggled-on");
        $(this).siblings().children(".dropdown-menu").attr("aria-hidden",true);
        $(this).siblings().children(".dropdown-toggle").attr("aria-expanded",false);

        if ($this.children(".nav-link").attr("href") === "#") {
            $this.children(".dropdown-toggle").toggleClass("toggled-on");
            $this.children(".dropdown-menu").toggleClass("toggled-on");

            $(this)
                .children(".dropdown-menu")
                .attr(
                    "aria-hidden",
                    $(this).children(".dropdown-menu").attr("aria-hidden") ===
                        "true"
                        ? "false"
                        : "true"
                );

            $(this)
                .children(".dropdown-toggle")
                .attr(
                    "aria-expanded",
                    $(this)
                        .children(".dropdown-toggle")
                        .attr("aria-expanded") === "false"
                        ? "true"
                        : "false"
                );
        }
    });

    $(".sub-menu-parent > ul").on("click", function (e) {
        e.stopPropagation();
    });
}

// jos sub menun linkillä  on linkkinä #, niin avataan pudotusvalikko klikattaessa
$(".sub-sub-menu-parent").on("click", function (e) {
    var $this = $(this);

    if ($this.children(".nav-link").attr("href") === "#") {
        $this.children(".dropdown-toggle").toggleClass("toggled-on");
        $this.children(".dropdown-menu").toggleClass("toggled-on");

        $(this)
            .children(".dropdown-menu")
            .attr(
                "aria-hidden",
                $(this).children(".dropdown-menu").attr("aria-hidden") ===
                    "true"
                    ? "false"
                    : "true"
            );

        $(this)
            .children(".dropdown-toggle")
            .attr(
                "aria-expanded",
                $(this).children(".dropdown-toggle").attr("aria-expanded") ===
                    "false"
                    ? "true"
                    : "false"
            );

        e.stopPropagation();
    }
});

function focusOut() {
    $(".sub-menu-parent .dropdown-menu").on("focusout", function () {
        setTimeout(function () {
            var is_in_menu = $(document.activeElement).closest(
                ".toggled-on"
            ).length;

            if (!is_in_menu) {
                $(".dropdown-menu").removeClass("toggled-on");
                $(".dropdown-toggle").removeClass("toggled-on");
            }
        }, 10);
    });
}

// var eventFired = 0;

if ($(window).width() > 960) {
    focusOut();
}

// else {
//   eventFired = 1;
// }

// $(window).on('resize', function() {
//     if (!eventFired) {
//         if ($(window).width() > 960) {
//           focusOut();
//         } else {
//           hamburger.classList.remove('is-active');

//         }
//     }
// });
// console.log(eventFired);

// Keyboard navigation
$(".menu-item a, button.dropdown-toggle").on("keydown", function (e) {
    if (
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.code) ==
        -1
    ) {
        return;
    }

    switch (e.code) {
        case "ArrowLeft": // Left key
            e.stopPropagation();

            if ($(this).hasClass("dropdown-toggle")) {
                $(this).prev("a").trigger("focus");
            } else if (
                $(this).parent().prev().children("button.dropdown-toggle")
                    .length
            ) {
                $(this)
                    .parent()
                    .prev()
                    .children("button.dropdown-toggle")
                    .trigger("focus");
            } else {
                $(this).parent().prev().children("a").trigger("focus");
            }

            if ($(this).is("ul ul ul.sub-menu.toggled-on li:first-child a")) {
                $(this)
                    .parents("ul.sub-menu.toggled-on li")
                    .children("button.dropdown-toggle")
                    .trigger("focus");
            }

            break;

        case "ArrowRight": // Right key
            e.stopPropagation();

            if ($(this).next("button.dropdown-toggle").length) {
                $(this).next("button.dropdown-toggle").trigger("focus");
            } else if ($(this).parent().next().find("input").length) {
                $(this).parent().next().find("input").trigger("focus");
            } else {
                $(this).parent().next().children("a").trigger("focus");
            }

            if ($(this).is("ul.sub-menu .dropdown-toggle.toggled-on")) {
                $(this)
                    .parent()
                    .find("ul.sub-menu li:first-child a")
                    .trigger("focus");
            }

            break;

        case "ArrowDown": // Down key
            e.stopPropagation();

            if ($(this).next().length) {
                $(this)
                    .next()
                    .find("li:first-child a")
                    .first()
                    .trigger("focus");
            } else if ($(this).parent().next().find("input").length) {
                $(this).parent().next().find("input").trigger("focus");
            } else {
                $(this).parent().next().children("a").trigger("focus");
            }

            if (
                $(this).is("ul.sub-menu a") &&
                $(this).next("button.dropdown-toggle").length
            ) {
                $(this).parent().next().children("a").trigger("focus");
            }

            if (
                $(this).is("ul.sub-menu .dropdown-toggle") &&
                $(this).parent().next().children(".dropdown-toggle").length
            ) {
                $(this)
                    .parent()
                    .next()
                    .children(".dropdown-toggle")
                    .trigger("focus");
            }

            break;

        case "ArrowUp": // Up key
            e.stopPropagation();

            if ($(this).parent().prev().length) {
                $(this).parent().prev().children("a").trigger("focus");
            } else {
                $(this)
                    .parents("ul")
                    .first()
                    .prev(".dropdown-toggle.toggled-on")
                    .trigger("focus");
            }

            if (
                $(this).is("ul.sub-menu .dropdown-toggle") &&
                $(this).parent().prev().children(".dropdown-toggle").length
            ) {
                $(this)
                    .parent()
                    .prev()
                    .children(".dropdown-toggle")
                    .trigger("focus");
            }

            break;
    }
});

menuWithTag();
